import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTypedTranslation } from '@app/hooks';
import { setExceptionHandler } from '@app/store/actions';
import { passwordManagerPolicyService } from '@app/services';
import { genericErrorToast } from '@app/helpers';
import { IPasswordServerPolicy } from '@app/models';

export interface IReceivedData {
    id: string;
}

const PasswordServerPolicyExtraDetailsComponent = (props: IReceivedData) => {
    const dispatch = useDispatch();
    const { translation } = useTypedTranslation();

    const [minLength, setMinLength] = useState(1);
    const [maxLength, setMaxLength] = useState(1);
    const [expireAfter, setExpireAfter] = useState(1);
    const [requireLowercase, setRequireLowercase] = useState(true);
    const [requireUppercase, setRequireUppercase] = useState(true);
    const [requireDigits, setRequireDigits] = useState(true);
    const [requireSpecial, setRequireSpecial] = useState(true);

    useEffect(() => {
        dispatch(setExceptionHandler(true));

        passwordManagerPolicyService.getPolicy(props.id, genericErrorToast, handleSuccess);
    }, []);

    const handleSuccess = (response: any) => {
        const results: IPasswordServerPolicy = response.data;

        if (results) {
            setMinLength(results.MinimumLength);
            setMaxLength(results.MaximumLength);
            setExpireAfter(results.ExpireEveryXDays);
            setRequireLowercase(results.RequireLowercase);
            setRequireUppercase(results.RequireUppercase);
            setRequireDigits(results.RequireDigits);
            setRequireSpecial(results.RequireSpecials);
        }
    };

    return (
        <>
            <div className='passwordVaults vaults__table-passwords'>
                <div className='vaults__table-passwords--wrapper'>
                    <span className='vaults__table-passwords--name'>{translation('PASSWORD_SERVER_POLICY_MINIMUM_LENGTH')}:</span>
                    <span className='vaults__table-passwords--description'>{minLength}</span>
                </div>
                <div className='vaults__table-passwords--wrapper'>
                    <span className='vaults__table-passwords--name'>{translation('PASSWORD_SERVER_POLICY_MAXIMUM_LENGTH')}:</span>
                    <span className='vaults__table-passwords--description'>{maxLength}</span>
                </div>
                <div className='vaults__table-passwords--wrapper'>
                    <span className='vaults__table-passwords--name'>{translation('EXPIRE_AFTER')}:</span>
                    <span className='vaults__table-passwords--description'>{expireAfter}</span>
                </div>

                <div className='vaults__table-passwords--wrapper'>
                    <span className='vaults__table-passwords--name'>{translation('PASSWORD_SERVER_POLICY_REQUIRE_LOWERCASE_NO_EXAMPLE')}:</span>
                    <span className='vaults__table-passwords--description'>
                        {requireLowercase ?
                            translation('YES')
                            :
                            translation('NO')
                        }
                    </span>
                </div>
                <div className='vaults__table-passwords--wrapper'>
                    <span className='vaults__table-passwords--name'>{translation('PASSWORD_SERVER_POLICY_REQUIRE_UPPERCASE_NO_EXAMPLE')}:</span>
                    <span className='vaults__table-passwords--description'>
                        {requireUppercase ?
                            translation('YES')
                            :
                            translation('NO')
                        }
                    </span>
                </div>
                <div className='vaults__table-passwords--wrapper'>
                    <span className='vaults__table-passwords--name'>{translation('PASSWORD_SERVER_POLICY_REQUIRE_DIGITS_NO_EXAMPLE')}:</span>
                    <span className='vaults__table-passwords--description'>
                        {requireDigits ?
                            translation('YES')
                            :
                            translation('NO')
                        }
                    </span>
                </div>

                <div className='vaults__table-passwords--wrapper'>
                    <span className='vaults__table-passwords--name'>{translation('PASSWORD_SERVER_POLICY_REQUIRE_SYMBOL_NO_EXAMPLE')}:</span>
                    <span className='vaults__table-passwords--description'>
                        {requireSpecial ?
                            translation('YES')
                            :
                            translation('NO')
                        }
                    </span>
                </div>
            </div>
        </>
    );
};

export default PasswordServerPolicyExtraDetailsComponent;